import * as Sentry from '@sentry/react';

// capture errors only in production build mode (yarn build)
// dev, qa, prod instances use yarn build
// DO NOT confuse NODE_ENV and REACT_APP_ENV
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
  });
}
